import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  legendText: {
    marginTop: 10,
    fontSize: 18,
    lineHeight: 23,
    color: '#000',
    opacity: 0.8,
  },
  titleDivider: {
    borderBottomWidth: 3,
  },
  message: {
    padding: 15,
    color: '#89909b',
    fontSize: 18,
    textAlign: 'center',
  },
  buttonsContainer: {
    width: '100%',
    alignItems: 'center',
  },
  confirmDeleteCardBtn: {
    width: 350,
    height: 68,
    borderRadius: 12,
    marginBottom: 20,
  },
  confirmDeleteCardBtnText: {
    color: '#FFF',
    fontSize: 18,
  },
  cancelBtn: {
    width: 300,
    fontSize: 18,
    marginBottom: 20,
  },
});
